module.exports = __webpack_public_path__ + "static/media/banner.ea34db36.png";